<style scoped>
    @import url("../../styles/smartControl/atuadorSC.scss");
</style>

<template>
    <div class="box_atuadorSC">

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- MSG CONFIRMAÇÃO INPUT UPDATE -->
        <div v-if="flagMsgInput && flagDevicesMenu && !flagLoading"
        :style="{
            'display':'flex','min-height':'60px','font-size':'1.2rem',
            'align-items':'center','justify-content':'center',
            'color':'white','width':'100%'
            }"
        >
            <!--<span>{{ msgForm }}</span>-->
            <span>{{ msgFinalInput }}</span>
        </div>

        <!-- dispositivos (controladores) associados a este sistema do cliente -->
        <div v-if="flagDevicesMenu && !flagLoading && !flagNotDevice" class="box_menu">

            <!-- CARD -->
            <div class="el_device" v-for="(el,i) in liDevices" :key="i"
            :style="{'background':el.b}"
            @click="callElDevice(i)"
            @mouseover="el.b = '#F39C12'"
            @mouseleave="el.b = ''"
            >
                <span class="txt_el_device">{{ el.nome_device }}</span>
                <v-icon size="72" class="mb-8">mdi-wrench-cog</v-icon>
            </div>
        </div>

        <!-- atuadores (pinos) associados ao dispositivo selecionado ao click -->
        <div v-if="!flagDevicesMenu && !flagLoading" class="box_menu">

            <!-- CARD -->
            <div class="el_device_b">

                <div class="line_btnToBack mb-2" @click="backOne()"
                @mouseover="hoverBackOne = '#f39c12'"
                @mouseleave="hoverBackOne = 'rgb(31,122,177)'"
                >
                    <v-icon large class="mr-2" :style="{'color':hoverBackOne}">mdi-arrow-left-thick</v-icon>
                    <span>Voltar</span>
                </div>

                <v-divider class="mt-1 mb-1"></v-divider>

                <!-- linha do título do atuador -->
                <div class="linha_tit_d_b">
                    <v-icon size="32">mdi-wrench-cog</v-icon>
                    <span class="ml-2">{{ el_device.nome_device }}</span>
                </div>

                <v-divider class="mt-1 mb-1"></v-divider>

                <!-- linha conexão -->
                <div class="linha_d_b">
                    <span>Conexão</span>
                    <span class="ml-2">{{ 'Aplicação: '+el_device.app_id }}</span>
                    <span class="ml-2">{{ 'Dispositivo: '+el_device.device }}</span>
                </div>

                <v-divider class="mt-1 mb-1"></v-divider>

                <span :style="{'color':'rgba(255,255,255,0.9)'}">Atuadores</span>

                <div class="box_atu">
                    <div class="sub_box_menu" v-for="(atu, j) in el_device.liAtuadores" :key="j">

                        <div class="sub_box_tit">{{ atu.titulo }}</div>
                        <v-divider class="mt-1 mb-1"></v-divider>

                        <div class="sub_linha_b">
                            <span class="tLinha">Decisão:</span>
                            
                            <div>
                                <!-- binding de atributo -->
                                <v-chip :style="{ color: atu.modelo === 'Limiar' ? '#F39C12' : '#397E9E' }" class="ml-2 mb-2">Limiar</v-chip>
                                <v-chip :style="{ color: atu.modelo === 'Periodico' ? '#F39C12' : '#397E9E' }" class="ml-2 mb-2">Periodico</v-chip>
                                <v-chip :style="{ color: atu.modelo === 'Manual' ? '#F39C12' : '#397E9E' }" class="ml-2 mb-2">Manual</v-chip>
                                <v-chip :style="{ color: atu.modelo === 'IA_indoor_v1' ? '#F39C12' : '#397E9E' }" class="ml-2 mb-2">Agente IA</v-chip>
                            </div>
                        </div>
                        <v-divider class="mt-1 mb-1"></v-divider>

                        <div class="sub_linha_b">
                            <span class="tLinha">Marcador:</span>
                            <v-chip class="ml-2" color="#397E9E">{{ atu.sub_marcador }}</v-chip>
                        </div>
                        <v-divider class="mt-1 mb-1"></v-divider>

                        <div class="sub_linha_b">
                            <span class="tLinha">Unidade:</span>
                            <v-chip class="ml-2" color="#397E9E">{{ atu.unidade }}</v-chip>
                        </div>
                        
                        <v-divider class="mt-1 mb-1"></v-divider>

                        <div class="sub_linha_b">
                            <span class="tLinha">Porta:</span>
                            <v-chip class="ml-2" color="#397E9E">{{ atu.pino }}</v-chip>
                        </div>
                        
                        <v-divider class="mt-1 mb-1"></v-divider>

                        <!-- LISTA DE SENSORES ASSOCIADOS AO ATUADOR -->
                        <div class="sub_linha_b_ass">
                            
                            <span>Sensores associados:</span>

                            <v-chip v-if="flagSensor" @click="backTwo()"
                            class="tit_sensor mb-1"
                            color="rgb(31,122,177)"
                            :style="{'justify-content':'center'}"
                            >
                                <v-icon>mdi-arrow-left-thick</v-icon>
                                <span class="ml-1">Voltar</span>
                            </v-chip>

                            <div v-for="(ass, w) in atu.ass_sensores" :key="w" class="el_ass ml-2" >

                                <!-- Exibição geral (lista de associados)-->
                                <v-chip @click="callConfigLimiar(w, j)" v-if="!flagSensor"
                                class="tit_sensor mb-1"
                                color="#397E9E"
                                :style="{'justify-content':'center'}"
                                >
                                    <span>{{ ass.titulo }}</span>
                                    <v-icon class="ml-1">mdi-cogs</v-icon>
                                </v-chip>

                                <!-- Exibição individual do associados selecionado para edição -->
                                <v-chip @click="callConfigLimiar(w, j)" v-if="flagSensor && index_sensor_ass == w"
                                class="tit_sensor mb-1"
                                color="#397E9E"
                                :style="{'justify-content':'center'}"
                                >
                                    <span>{{ ass.titulo }}</span>
                                    <v-icon class="ml-1">mdi-cogs</v-icon>
                                </v-chip>

                                <!-- MENU CONFIG SENSOR selecionado 
                                v-if="flagSensor && j == index_atu" 
                                -->

                                <!-- Exibir apenas o associado selecionado para edição -->
                                <div class="menu_sensor" v-if="flagSensor && index_sensor_ass == w">

                                    <!-- lista de panels -->
                                    <v-expansion-panels accordion class="cardExpansor">

                                        <!-- painel -->
                                        <v-expansion-panel class="el_cardExpansor mt-1">

                                            <!-- titulo painel -->
                                            <v-expansion-panel-title class="titCardExpansor">Limiar superior</v-expansion-panel-title>

                                            <!-- corpo painel -->
                                            <v-expansion-panel-text class="respCardExpansor">

                                                <div class="subtit_def_prod">status</div>
                                                <v-radio-group 
                                                inline 
                                                v-model="rBtnSupSensor"
                                                @update:modelValue="onSupStatusChange"
                                                >
                                                    <v-radio label="ON" value="on"></v-radio>
                                                    <v-radio label="OFF" value="off"></v-radio>
                                                </v-radio-group>

                                                <div class="linhaForm" v-if="rBtnSupSensor == 'on'">
                                                    <span class="tLinha">Valor limiar sensor:</span>
                                                    <div class="ml-2 elInput"
                                                    :style="{'border':'1px solid #395872','border-radius':'12px','height':'55px','padding':'4px'}"
                                                    >
                                                        <v-text-field
                                                        v-model="ass.limiar_sup.valor"
                                                        class="w-100"
                                                        variant="plain"
                                                        bg-color="transparent"
                                                        :placeholder="ass.limiar_sup.valor"
                                                        @update:modelValue="verificar_limiar('sup')"
                                                        /><!--@change="verificar_limiar('sup')"-->
                                                    </div>
                                                </div>

                                                <div class="linhaForm" v-if="rBtnSupSensor == 'on'">
                                                    <span class="tLinha">Tipo:</span>
                                                    <div class="ml-2 elSelect">
                                                        <v-autocomplete
                                                        v-model="tipoSupSelected"
                                                        :items="liSelectTipo"
                                                        color="rgb(247,215,46)"
                                                        class="w-100"
                                                        variant="plain"
                                                        bg-color="transparent"
                                                        @update:modelValue="(val) => trocarTipo(val, 'sup')"
                                                        ></v-autocomplete>
                                                    </div>
                                                </div>

                                                <div class="linhaForm" v-if="tipoSupSelected == 'temporizado' && rBtnSupSensor == 'on'">
                                                    <!--<span class="tLinha">Segundos:</span>-->
                                                    <!--<v-chip class="ml-2" color="#397E9E">{{ formLocal.timeout_tempo_hr }}</v-chip>-->
                                                    <span class="tLinha">Tempo:</span>
                                                    <div class="ml-2 elInput">
                                                        <v-text-field
                                                            v-model="el_ass.limiar_sup.act"
                                                            class="w-100"
                                                            color="rgb(247,215,46)"
                                                            variant="plain"
                                                            bg-color="transparent"
                                                            :placeholder="el_ass.limiar_sup.act"
                                                            @update:modelValue="verificar_timeout('sup')"
                                                        />
                                                        <!-- placeholder="00:00:01" 
                                                        @change="verificar_timeout('sup')"-->
                                                    </div>
                                                </div>
                                                <div class="linhaForm" v-else-if="tipoSupSelected == 'direto' && rBtnSupSensor == 'on'">
                                                    <span class="tLinha">Atuação:</span>
                                                    <!--<v-chip class="ml-2" color="#397E9E">{{ comandoFront }}</v-chip>-->
                                                    <div class="ml-2 elSelect">
                                                        <v-autocomplete
                                                        v-model="comandoFrontSup"
                                                        :items="liSelectComando"
                                                        color="rgb(247,215,46)"
                                                        class="w-100"
                                                        variant="plain"
                                                        bg-color="transparent"
                                                        @update:modelValue="(val) => trocarComando(val, 'sup')"
                                                        ></v-autocomplete>
                                                    </div>
                                                </div>
                                            </v-expansion-panel-text>

                                        </v-expansion-panel>

                                        <v-expansion-panel class="el_cardExpansor mt-1">

                                            <!-- titulo painel -->
                                            <v-expansion-panel-title class="titCardExpansor">Limiar inferior</v-expansion-panel-title>

                                            <!-- corpo painel -->
                                            <v-expansion-panel-text class="respCardExpansor">

                                                <div class="subtit_def_prod">status</div>
                                                <v-radio-group 
                                                inline 
                                                v-model="rBtnInfSensor"
                                                @update:modelValue="onInfStatusChange"
                                                >
                                                    <v-radio label="ON" value="on"></v-radio>
                                                    <v-radio label="OFF" value="off"></v-radio>
                                                </v-radio-group>

                                                <div class="linhaForm" v-if="rBtnInfSensor == 'on'">
                                                    <span class="tLinha">Valor limiar sensor:</span>
                                                    <div class="ml-2 elInput"
                                                    :style="{'border':'1px solid #395872','border-radius':'12px','height':'55px','padding':'4px'}"
                                                    >
                                                        <v-text-field
                                                        v-model="ass.limiar_inf.valor"
                                                        class="w-100"
                                                        color="rgb(247,215,46)"
                                                        variant="plain"
                                                        bg-color="transparent"
                                                        :placeholder="ass.limiar_inf.valor"
                                                        @update:modelValue="verificar_limiar('inf')"
                                                        /><!--@change="verificar_limiar('inf')"-->
                                                    </div>
                                                </div>

                                                <div class="linhaForm" v-if="rBtnInfSensor == 'on'">
                                                    <span class="tLinha">Tipo:</span>
                                                    <div class="ml-2 elSelect">
                                                        <v-autocomplete
                                                        v-model="tipoInfSelected"
                                                        :items="liSelectTipo"
                                                        color="rgb(247,215,46)"
                                                        class="w-100"
                                                        variant="plain"
                                                        bg-color="transparent"
                                                        @update:modelValue="(val) => trocarTipo(val, 'inf')"
                                                        ></v-autocomplete>
                                                    </div>
                                                </div>

                                                <div class="linhaForm" v-if="tipoInfSelected == 'temporizado' && rBtnInfSensor == 'on'">
                                                    <!--<span class="tLinha">Segundos:</span>-->
                                                    <!--<v-chip class="ml-2" color="#397E9E">{{ formLocal.timeout_tempo_hr }}</v-chip>-->
                                                    <span class="tLinha">Tempo:</span>
                                                    <div class="ml-2 elInput">
                                                        <v-text-field
                                                            v-model="el_ass.limiar_inf.act"
                                                            class="w-100"
                                                            color="rgb(247,215,46)"
                                                            variant="plain"
                                                            bg-color="transparent"
                                                            :placeholder="el_ass.limiar_inf.act"
                                                            @update:modelValue="verificar_timeout('inf')"
                                                        />
                                                        <!-- placeholder="00:00:01" 
                                                        @change="verificar_timeout('inf')"-->
                                                    </div>
                                                </div>
                                                <div class="linhaForm" v-else-if="tipoInfSelected == 'direto' && rBtnInfSensor == 'on'">
                                                    <span class="tLinha">Atuação:</span>
                                                    <!--<v-chip class="ml-2" color="#397E9E">{{ comandoFront }}</v-chip>-->
                                                    <div class="ml-2 elSelect">
                                                        <v-autocomplete
                                                        v-model="comandoFrontInf"
                                                        :items="liSelectComando"
                                                        color="rgb(247,215,46)"
                                                        class="w-100"
                                                        variant="plain"
                                                        bg-color="transparent"
                                                        @update:modelValue="(val) => trocarComando(val, 'inf')"
                                                        ></v-autocomplete>
                                                    </div>
                                                </div>
                                            </v-expansion-panel-text>

                                        </v-expansion-panel>

                                    </v-expansion-panels>

                                    <v-btn 
                                    color="success"
                                    :disabled="!isDirty"
                                    class="mt-2" 
                                    block 
                                    @click="send2update()"
                                    >
                                        Atualizar
                                    </v-btn>

                                    <div v-if="flagMsgForm"
                                    :style="{'min-height':'60px','padding':'6px','font-size':'0.9rem','color':colorMsg}"
                                    >
                                        <span>{{ msgForm }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--<v-divider class="mt-1 mb-1"></v-divider>

                         LISTA DE periodo automático suspenso ASSOCIADOS AO ATUADOR 
                        <div class="sub_linha_b_ass">
                            teste
                        </div>-->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {

    data() {
        return {
            //
            flagLoading:true,
            flagMsgInput:false,
            msgFinalInput:"",
            flagNotDevice:false, // para clientes sem atuadores

            //
            liDevices:[],
            index_device:null,
            liDevicesSnap:[],
            liAtuadores:[],
            el_device:{},
            el_ass:{},
            index_atu:null,
            index_sensor_ass:null,
            countGeralPag:0, // aux reentrada na pagina edit

            //
            flagDevicesMenu:true,
            hoverBackOne:'rgb(31,122,177)',

            // -- ass sensores
            flagSensor:false,

            rBtnSupSensor:null, // radios
            rBtnInfSensor:null, // radios

            liSelectTipo:['direto','temporizado'],
            liSelectComando:['ligar','desligar'],
            
            tipoSupSelected:'',
            comandoFrontSup:'',

            tipoInfSelected:'',
            comandoFrontInf:'',

            // resposta ao input
            msgForm:'',
            colorMsg:'',
            flagMsgForm:true,
            flagBtnChange:false,

            // mudança ao preencher
            //elEdit:null,
            elEditSnap:null,
        }
    },

    computed: {
        isDirty() {
            // -- comparação profunda simples
            //return !deepEqual(this.elEdit, this.elEditSnap)
            return !this.deepEqual(this.el_ass, this.elEditSnap)
        }
    },

    methods:{

        // -- aux para computed verif mudança entre o doc init e o doc editado
        deepEqual(a, b) {
            // suficiente para objetos/arrays “puros” (sem funções/Date/Map/Set)
            return JSON.stringify(a) === JSON.stringify(b)
        },

        HHMMSStoSegundos(hhmmss) {
            // Quebra a string "HH:MM:SS" em partes
            const [h, m, s] = hhmmss.split(":").map(Number);
            // Converte para inteiro em segundos
            return (h * 3600) + (m * 60) + s;
        },

        segundosParaHHMMSS(totalSegundos) {

            let horas = Math.floor(totalSegundos / 3600);
            let minutos = Math.floor((totalSegundos % 3600) / 60);
            let segundos = totalSegundos % 60;

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
        },

        backOne() { 
            // -- voltar ao menu dispositivos (controladores)
            this.flagDevicesMenu = true 
            // -- reset lista atuadores do controlador.
            this.flagSensor = false
            this.el_device.liAtuadores = this.liDevicesSnap[this.index_device]['liAtuadores']
        },

        backTwo() { 
            // -- voltar ao menu atuadores
            this.el_device.liAtuadores = this.liDevicesSnap[this.index_device]['liAtuadores']
            this.flagSensor = false 
        },

        callConfigLimiar(index_sensor_ass, index_atu) { 
            // --> seleciona config pelo index
            //console.log('index_sensor_ass: ',index_sensor_ass)
            //console.log('index_atu: ',index_atu)
            //console.log('index_device: ',this.index_device)
            //this.el_ass = this.liDevices[this.index_device]['liAtuadores'][index_atu]['ass_sensores'][index_sensor_ass]
            //console.log('this.liDevices[index_device]: ',this.liDevices[this.index_device])

            /*if (this.countGeralPag > 0) {
                // se nao for a 1a entrada (evitar conflito devido a modificação do tam list)
                this.el_ass = this.elEditSnap // 06/11/2025 (porém conflita se houver mais de um associado)
            }
            else {
                this.el_ass = this.liDevices[this.index_device]['liAtuadores'][index_atu]['ass_sensores'][index_sensor_ass]
            }*/

            this.elEditSnap = {} // reset clone (usado para comparar edição em tempo real).
            this.el_ass = {} // reset elemento associado selecionado para edição.

            this.el_ass = this.liDevices[this.index_device]['liAtuadores'][index_atu]['ass_sensores'][index_sensor_ass]

            this.index_atu = index_atu // exibir apenas no atuador em edição | [j]
            this.index_sensor_ass = index_sensor_ass // [w]

            this.rBtnSupSensor = this.el_ass.limiar_sup.status
            this.rBtnInfSensor = this.el_ass.limiar_inf.status

            //let s = null // usado na verificação de formato numerico, abaixo.

            //console.log('this.el_ass: ',this.el_ass)

            // -- formatar elemento sup para exibição.
            if (this.el_ass.limiar_sup.tipo == "") { 

                //this.el_ass.limiar_sup.tipo = "temporizado" # <-- redundante?
                this.tipoSupSelected = "temporizado" 
                // -- converter string do inteiro para o formato hh:mm:ss editável.
                //console.log('[temporizado] el_ass.limiar_sup.act: ',this.el_ass.limiar_sup.act)

                const funcFlagBool_isHHMMSS = (v) => /^\d{2}:\d{2}:\d{2}$/.test(v ?? ''); // -- verif formato
                // -- já foi convertido nesta interação do cliente?
                let s = this.el_ass.limiar_sup.act
                if (!funcFlagBool_isHHMMSS(s)) {
                    // -- se flase, então não está ainda no formato hh:mm:ss
                    let int_sup = 1
                    if (this.el_ass.limiar_sup.act != "") { int_sup = parseInt(this.el_ass.limiar_sup.act); }
                    s = this.segundosParaHHMMSS(int_sup) // totalSegundos
                    this.el_ass.limiar_sup.act = s
                    this.verificar_timeout('sup')
                }
            }
            else {
                this.tipoSupSelected = "direto"
                //console.log('[direto] el_ass.limiar_sup.act: ',this.el_ass.limiar_sup.act)
                this.comandoFrontSup = this.el_ass.limiar_sup.act // -- so há comando direto, se tipo direto.
            }

            // -- formatar elemento inf para exibição.
            if (this.el_ass.limiar_inf.tipo == "") {
                this.tipoInfSelected = "temporizado" 
                
                const funcFlagBool_isHHMMSS_inf = (s) => /^\d{2}:\d{2}:\d{2}$/.test(s ?? ''); // -- verif formato
                // -- já foi convertido nesta interação do cliente?
                let s = this.el_ass.limiar_inf.act
                if (!funcFlagBool_isHHMMSS_inf(s)) {
                    // -- converter string do inteiro para o formato hh:mm:ss editável.
                    let int_inf = 1
                    if (this.el_ass.limiar_inf.act != "") { int_inf = parseInt(this.el_ass.limiar_inf.act); }
                    s = this.segundosParaHHMMSS(int_inf) // totalSegundos
                    this.el_ass.limiar_inf.act = s
                    this.verificar_timeout('inf')
                }
            }
            else {
                this.tipoInfSelected = "direto"
                this.comandoFrontInf = this.el_ass.limiar_inf.act
            }

            // MUDAR FLAG DEPOIS DAS FORMATAÇÕES
            // -- reload lista atuadores com um unico atuador, se o cliente pedir edição.
            /*if (this.flagSensor == false) {
                this.el_device.liAtuadores = [ this.liDevices[this.index_device]['liAtuadores'][index_atu] ]
                this.flagSensor = true
                this.elEditSnap = structuredClone(this.el_ass) // -- estado “original”
            }*/
            if (this.flagSensor == false) {
                //console.log('[open expansive] this.flagSensor: ',this.flagSensor)
                //console.log('this.liDevicesSnap: ',this.liDevicesSnap)
                this.el_device.liAtuadores = [ this.liDevices[this.index_device]['liAtuadores'][index_atu] ]
                this.flagSensor = true
            }
            else {
                //console.log('[close expansive] this.flagSensor: ',this.flagSensor)
                //console.log('this.liDevicesSnap: ',this.liDevicesSnap)
                this.el_device.liAtuadores = this.liDevicesSnap[this.index_device]['liAtuadores']
                this.flagSensor = false // reset
            }

            // SNAP da edição de limiares.
            // elemento atual que será editado
            //this.elEdit = structuredClone(this.el_ass) // -- estado “vivo”
            // <--- é o próprio this.el_ass
            // snapshot de comparação
            this.elEditSnap = structuredClone(this.el_ass) // -- estado “original”
            this.countGeralPag++

            // -- mudar estado.
            //this.flagSensor = !this.flagSensor
        },

        send2update() {

            if (this.flagBtnChange == false) {this.isDirty=true;return;} // indica erro de preenchimento (desabilitar btn)
            // -- esta função só deve ser chamada se houve alteração no formulário. (já validado neste ponto)
            
            // -- ajustar formato antes do input de update.
            // -- verificação local: temporizador deve ser inteiro e não string hhmmss.
            let segundos = null

            // SUPERIOR
            if (this.rBtnSupSensor == 'on') {

                // -- tipo do disparo.
                if (this.tipoSupSelected == 'temporizado') { 
                    const hhmmss = this.el_ass.limiar_sup.act
                    segundos = this.HHMMSStoSegundos(hhmmss)
                    //console.log('[verif call] segundos: ',segundos)
                    if (segundos > 241) { 
                        this.flagMsgForm = true
                        this.msgForm = 'Tempo máximo 4 minutos para esta versão. Utilize o disparo direto para períodos maiores.'
                        this.colorMsg = '#ec5858'
                        this.flagBtnChange = false // indica erro de preenchimento (desabilitar btn)
                        //this.handleLoading = false // desabilitar loading para exibir msg erro
                        return
                    }
                    this.el_ass.limiar_sup.act = segundos
                    this.colorMsg = '' // reset (retirar vermelho)
                    this.flagMsgForm = false // reset (caso tenha ocorrido (s > 254s))
                    this.flagBtnChange = true // reset
                }
                else {
                    this.el_ass.limiar_sup.act = this.comandoFrontSup // comando direto
                }

                // -- valor do limiar.
                if (this.el_ass.limiar_sup.valor == "") { 
                    this.flagMsgForm = true
                    this.msgForm = 'Todos os campos devem ser preenchidos.'
                    this.colorMsg = '#ec5858'
                    //this.handleLoading = false // desabilitar loading para exibir msg erro
                    return
                }

                // -- status.
                this.el_ass.limiar_sup.status = this.rBtnSupSensor

            } else { this.el_ass.limiar_sup.act = "" } // reset

            // INFERIOR
            if (this.rBtnInfSensor == 'on') {

                if (this.tipoInfSelected == 'temporizado') { 
                    const hhmmss = this.el_ass.limiar_inf.act
                    segundos = this.HHMMSStoSegundos(hhmmss)
                    //console.log('[verif call] segundos: ',segundos)
                    if (segundos > 241) { 
                        this.flagMsgForm = true
                        this.msgForm = 'Tempo máximo 4 minutos para esta versão. Utilize o disparo direto para períodos maiores.'
                        this.colorMsg = '#ec5858'
                        //this.handleLoading = false // desabilitar loading para exibir msg erro
                        return
                    }
                    this.el_ass.limiar_inf.act = segundos
                    this.colorMsg = '' // reset (retirar vermelho)
                    this.flagMsgForm = false // reset (caso tenha ocorrido (s > 254s))
                }
                else {
                    this.el_ass.limiar_inf.act = this.comandoFrontInf // comando direto
                }

                // -- valor do limiar.
                if (this.el_ass.limiar_inf.valor == "") { 
                    this.flagMsgForm = true
                    this.msgForm = 'Todos os campos devem ser preenchidos.'
                    this.colorMsg = '#ec5858'
                    //this.handleLoading = false // desabilitar loading para exibir msg erro
                    return
                }

                // -- status.
                this.el_ass.limiar_inf.status = this.rBtnInfSensor

            } else { this.el_ass.limiar_inf.act = "" } // reset

            // -- cd REMONTAR ELEMENTO PARA INPUT.
            //this.liDevices[this.index_device]['liAtuadores'][this.index_atu]['ass_sensores'][this.index_sensor_ass] = this.el_ass
            // ( ! ) (possível confusão) --> this.liAtuadores é a lista principal root, contendo dispositivos
            // que por sua vez contêm atuadores (pinos). [a nomeclatura ficou confusa]
            // <-- o nome abaixo é o nome root para o envio:
            this.liAtuadores[this.index_device]['params'][this.index_atu]['ass_sensores'][this.index_sensor_ass] = this.el_ass

            let sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            // -- para versão demo (tangerina) não é permitido usuários não adm editarem.
            if ( (sistema == 'upinc1') && (cl != 'geral@upinc.pt') ) { 
                this.flagMsgForm = true;
                this.msgForm = 'Versão não habilitada para atualização.';
                this.colorMsg = '#ec5858';
                return;
            }

            // -- chamar update.
            this.flagLoading = true // ==> encerra edição e após req reload

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = {
                'cliente':cl, 
                'sistema':sistema,
                'el2up':this.liAtuadores
            }

            let self = this
            
            const url = self.$store.state.pathAxiosBASE + '/upagentatux'

            axios.post(url, params, {headers}).then(function (res) {

                console.log(res.data.result)

                self.flagMsgInput = true
                self.msgFinalInput = "Atualização enviada. A página atual será atualizada."
                self.flagDevicesMenu = true // habilitar main devices (resetar clone edit)
                self.flagLoading = false // desabilitar load

                setTimeout(() => {
                    // reaload pag apos edit ok (para redundãncia de segurança dos gatilhos)
                    //self.flagLoading = false // desabilitar load
                    window.location.reload(true) 
                    //window.scrollTo(0,0)
                    //self.flagDevicesMenu = true // habilitar main devices (resetar clone edit)
                },2000)
            })
            window.scrollTo(0,0)
        },

        callElDevice(index_device) {
            //console.log(index_device)

            this.el_device = this.liDevices[index_device]
            this.index_device = index_device
            this.flagDevicesMenu = false // abrir menu dos pinos (atuadores)
        },

        onSupStatusChange(statusSup) { 
            this.rBtnSupSensor = statusSup
            this.el_ass.limiar_sup.status = statusSup

            if (statusSup == 'on') { this.trocarTipo('direto', 'sup') } // init
            else {
                // RESETAR ELEMENTOS
                this.el_ass.limiar_sup.valor = ""
                this.el_ass.limiar_sup.act = ""
            }
        },

        onInfStatusChange(statusInf) { 
            this.rBtnInfSensor = statusInf
            this.el_ass.limiar_inf.status = statusInf

            if (statusInf == 'on') { this.trocarTipo('direto', 'inf') } // init
            else {
                // RESETAR ELEMENTOS
                this.el_ass.limiar_inf.valor = ""
                this.el_ass.limiar_inf.act = ""
            }
        },

        trocarTipo(tipoSelected, flagStrLimiar) {
            //console.log('tipoSelected: ',tipoSelected)
            
            if (tipoSelected == 'temporizado') {

                // local var -> global scope var
                if (flagStrLimiar == 'sup') { 
                    this.tipoSupSelected = tipoSelected 

                    if (this.el_ass.limiar_sup.act == undefined) { // senao for vazio
                        // -- obter valor em segundos mínimo (formato hhmmss)
                        const segundos_exib = this.segundosParaHHMMSS(1) // int -> string
                        this.el_ass.limiar_sup.act = segundos_exib // string
                    }
                    else{ this.el_ass.limiar_sup.act = "00:00:01"; }
                }
                if (flagStrLimiar == 'inf') { 
                    this.tipoInfSelected = tipoSelected 
                
                    if (this.el_ass.limiar_inf.act == undefined) { // senao for vazio
                        // -- obter valor em segundos mínimo (formato hhmmss)
                        const segundos_exib = this.segundosParaHHMMSS(1) // int -> string
                        this.el_ass.limiar_inf.act = segundos_exib // string
                    }
                    else{ this.el_ass.limiar_inf.act = "00:00:01"; }
                }
                
            }
            
            if (tipoSelected == 'direto') {
                //this.tipoSelected = tipoSelected // local var -> global scope var
                if (flagStrLimiar == 'sup') { 
                    this.tipoSupSelected = tipoSelected 

                    if (!this.comandoFrontSup || this.comandoFrontSup.trim() === '') {
                        this.comandoFrontSup = 'desligar'
                        //console.log('[trocarTipo] this.comandoFront: ',this.comandoFront)
                    }
                }
                if (flagStrLimiar == 'inf') { 
                    this.tipoInfSelected = tipoSelected 

                    if (!this.comandoFrontInf || this.comandoFrontInf.trim() === '') {
                        this.comandoFrontInf = 'desligar'
                        //console.log('[trocarTipo] this.comandoFront: ',this.comandoFront)
                    }
                }
            }
        },

        trocarComando(comandoFront, flagStrLimiar) {
            if (flagStrLimiar == 'sup') { this.comandoFrontSup = comandoFront }
            if (flagStrLimiar == 'inf') { this.comandoFrontInf = comandoFront }
        },

        verificar_timeout(flagStr) {

            if (flagStr == 'sup') {
                
                let s = (this.el_ass.limiar_sup.act || '').trim()
                // sanear para HH:MM:SS se quiser (regex/parse)
                if (!/^\d{2}:\d{2}:\d{2}$/.test(s)) {
                    this.el_ass.limiar_sup.act = "00:00:01"

                    this.msgForm = 'Formato 00:00:00 obrigatório para o temporizador.'
                    this.colorMsg = '#ec5858' // vermelho suave
                    this.flagMsgForm = true
                    this.flagBtnChange = false // indica erro de preenchimento (desabilitar btn)
                }
                else {
                    this.msgForm = ''
                    this.colorMsg = ''
                    this.flagMsgForm = false
                    this.flagBtnChange = true
                }
            }
            else {

                let s = (this.el_ass.limiar_inf.act || '').trim()
                // sanear para HH:MM:SS se quiser (regex/parse)
                if (!/^\d{2}:\d{2}:\d{2}$/.test(s)) {
                    this.el_ass.limiar_inf.act = "00:00:01"

                    this.msgForm = 'Formato 00:00:00 obrigatório para o temporizador.'
                    this.colorMsg = '#ec5858' // vermelho suave
                    this.flagMsgForm = true
                    this.flagBtnChange = false // indica erro de preenchimento (desabilitar btn)
                }
                else {
                    this.msgForm = ''
                    this.colorMsg = ''
                    this.flagMsgForm = false
                    this.flagBtnChange = true
                }
            }
        },

        verificar_limiar(flagStr) {

            let s = null

            if (flagStr == 'sup') {

                s = (this.el_ass.limiar_sup.valor || '').trim()

                // troca vírgulas por ponto automaticamente
                if (s.includes(',')) {
                    s = s.replace(/,/g, '.')
                    this.el_ass.limiar_sup.valor = s
                }
            }
            else {

                s = (this.el_ass.limiar_inf.valor || '').trim()

                // troca vírgulas por ponto automaticamente
                if (s.includes(',')) {
                    s = s.replace(/,/g, '.')
                    this.el_ass.limiar_inf.valor = s
                }
            }

            // aceita: "123" ou "123.45" (sem sinal, sem múltiplos pontos, sem ".45" sem zero à esquerda)
            const reNumero = /^\d+(?:\.\d+)?$/
            
            if (!reNumero.test(s)) {
                this.msgForm = 'Informe um número inteiro ou decimal com ponto (ex.: 10 ou 10.5).'
                this.colorMsg = '#ec5858' // vermelho suave
                this.flagMsgForm = true
                this.flagBtnChange = false // indica erro de preenchimento (desabilitar btn)
            }
            else {
                this.msgForm = ''
                this.colorMsg = ''
                this.flagMsgForm = false
                this.flagBtnChange = true
            }
        },

        preInit() {
            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result)

                const el = res.data.result // agent_unit
                self.liAtuadores = el['atuadores'] // lista de controladores contendo atuadores (pinos)
                
                let c=0
                while ( c < self.liAtuadores.length ) {

                    // hierarquia do documento:
                    // lista dispositivos -> lista atuadores -> 

                    /*let params = liAtuadores[c]['params']
                    let liAtu = [] // reset
                    let j=0
                    while (j < params.length) {

                        if (params[j]['status'] == 'on') { 

                            liAtu.push({'tit':params[j]['titulo'],'porta':params[j]['pino']})
                        }
                        j++
                    }*/
                    self.liDevices.push({
                        'nome_device':self.liAtuadores[c]['nome'], 
                        'device':self.liAtuadores[c]['device'], 
                        'app_id':self.liAtuadores[c]['app_id'],
                        //'liAtuadores':liAtu,
                        'liAtuadores':self.liAtuadores[c]['params'],
                        'b':''
                    })
                    c++
                }
                //self.liDevicesSnap = self.liDevices // cópia por referência não preserva conteúdo original.
                self.liDevicesSnap = JSON.parse(JSON.stringify(self.liDevices));
                //console.log('[init] this.liDevicesSnap: ',self.liDevicesSnap)

                if (self.liAtuadores[0]['device'] == "") {
                    //
                    self.msgFinalInput = "Nenhum controlador habilitado."
                    self.flagMsgInput = true
                    self.flagNotDevice = true
                }

                self.flagLoading = false
            })
        },
    },

    created() {
        // <-- este é um componente filho de AtuadoresSmartControl.vue
        window.scrollTo(0,0)

        // -- condicionar ao sistema selecionado pelo cliente.
        this.preInit()
    }
}
</script>
